const CREDS = [
  { k: "01", label: "Music Production", value: "10+ years" },
  { k: "02", label: "Education", value: "Full Sail University" },
  { k: "03", label: "Certification", value: "Pro Tools Certified" },
  { k: "04", label: "Disciplines", value: "Music · Photo · Travel · Business" },
];

export default function About() {
  return (
    <section id="about" className="py-24 md:py-36 bg-warmwhite" data-testid="about-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <p className="text-[11px] uppercase tracking-widest-custom text-olive mb-6" data-testid="about-eyebrow">01 — About</p>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative aspect-[4/5] overflow-hidden bg-taupe/20">
              <img
                src="https://customer-assets.emergentagent.com/job_james-portfolio-1/artifacts/7gaw95y9_IMG_6738.jpg"
                alt="James Douglas in the studio"
                className="w-full h-full object-cover"
                data-testid="about-portrait"
              />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <p className="font-serif italic text-warmwhite text-2xl drop-shadow">James, in studio</p>
                <p className="text-[10px] uppercase tracking-widest-custom text-warmwhite/80">2025</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight" data-testid="about-title">
              A creative practice rooted in <span className="italic text-gold">faith</span>, sharpened by craft.
            </h2>

            <div className="mt-10 space-y-6 text-charcoal/80 text-base md:text-lg leading-relaxed max-w-2xl">
              <p>
                {`I'm James Douglas — an artist and entrepreneur working across the intersection of sound, image, and story. For over a decade I've helped artists, founders, and families bring meaningful work into the world.`}
              </p>
              <p>
                Under <span className="font-serif italic">James 1:1</span>, I run a creative hub for music production, photography, project management, and travel — a single roof for every kind of dream that deserves to be executed well.
              </p>
            </div>

            <dl className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-y-8 gap-x-12 border-t border-taupe/40 pt-10">
              {CREDS.map((c) => (
                <div key={c.k} className="flex items-start gap-5" data-testid={`about-cred-${c.k}`}>
                  <span className="font-serif italic text-gold text-2xl leading-none mt-1">{c.k}</span>
                  <div>
                    <dt className="text-[11px] uppercase tracking-widest-custom text-charcoal/50">{c.label}</dt>
                    <dd className="font-serif text-xl md:text-2xl mt-1">{c.value}</dd>
                  </div>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
